import styled from 'styled-components';
import Link from '../Link';
import { Typography } from '../Typography';

export const TabletWrap = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakPoints.md}) {
    display: flex;
  }
`;
export const MobileWrap = styled.div`
  width: 3.5rem;
  @media (min-width: ${({ theme }) => theme.breakPoints.md}) {
    display: none;
  }
`;

export const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 0 80px;
  justify-content: space-between;
  display: none;
  z-index: 2;
  background: ${({ theme }) => theme.colors.functional.gray2};
  height: 64px;
  @media (max-width: ${({ theme }) => theme.navBreakPoints.lg}) {
    display: flex;
  }
  a {
    height: 3.6rem;
    display: flex;
    img,
    svg {
      width: 100%;
    }
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-center: center;
  align-items: center;
  justify-content: center;
  a {
    display: flex;
  }
`;

export const Hamburger = styled.div`
  position: fixed;
  right: 80px;
  height: 64px;
  top: 0;
  cursor: pointer;
  width: 1.8rem;
  z-index: ${({ theme }) => theme.zIndex.backdrop + 1};
  display: flex;
  svg {
    fill: ${({ theme }) => theme.colors.primary.main};
    width: 1.8rem;
  }
`;

// Total height is 80px
// Nav buttons are 48px
// 80 - 48 = 32px / 2 = 16px
export const Container = styled.div`
  padding: 16px 0;
`;

export const ModalWrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 64px;
  bottom: 0;
  z-index: 2;
  background: ${({ theme }) => theme.colors.functional.gray2};
`;

export const LinksWrapper = styled.div`
  padding: 8vh 0 4vh;
`;

export const StyledLink = styled(Link)<{ isActive?: boolean }>`
  margin-bottom: 2vh !important;
  display: block !important;
  height: auto !important;
  border: none;
  :hover {
    color: ${({
      theme: {
        colors: {
          primary: { main },
        },
      },
    }) => main};
  }
  ${({
    isActive,
    theme: {
      colors: {
        primary: { main },
      },
    },
  }) => isActive && `color: ${main};`}
`;

export const StyledSpan = styled(Typography)`
  display: inline-block;
  position: relative;
  height: 32px;
  line-height: 32px;
  font-family: ${({
    theme: {
      fonts: { archivo },
    },
  }) => archivo};
  font-size: 14px;
  color: inherit;
  font-weight: 700;
`;

export const StyledEm = styled.em`
  display: block;
  height: 2px;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({
    theme: {
      colors: {
        primary: { main },
      },
    },
  }) => main};
`;
